import { errorNames, screenNames, stepNames } from './types';

export const stepNamesConst: Record<stepNames, stepNames> = {
  CUSTOMER_IDENTIFICATION: 'CUSTOMER_IDENTIFICATION',
  CUSTOMER_REGISTRATION: 'CUSTOMER_REGISTRATION',
  CONTACT_INFORMATION: 'CONTACT_INFORMATION',
  SMS_VERIFICATION: 'SMS_VERIFICATION',
  EMAIL_VERIFICATION: 'EMAIL_VERIFICATION',
  LOAN_AMOUNT_AND_PURPOSES: 'LOAN_AMOUNT_AND_PURPOSES',
  REPAYMENT_TERMS: 'REPAYMENT_TERMS',
  BANK_ACCOUNT_REFERENCE: 'BANK_ACCOUNT_REFERENCE',
  PAYMENT_METHOD: 'PAYMENT_METHOD',
  IDENTITY_VERIFICATION_STATUS_PENDING: 'IDENTITY_VERIFICATION_STATUS_PENDING',
  IDENTITY_VERIFICATION_START: 'IDENTITY_VERIFICATION_START',
  REVIEW_AND_SEND_LINK: 'REVIEW_AND_SEND_LINK',
  REVIEW_AND_SUBMIT: 'REVIEW_AND_SUBMIT',
  MERCHANT_IDENTIFICATION: 'MERCHANT_IDENTIFICATION',
  MERCHANT_CONTACT_INFORMATION: 'MERCHANT_CONTACT_INFORMATION',
  REJECTION: 'REJECTION',
  SUCCESS: 'SUCCESS',
};

export const screenNamesConst: Record<screenNames, screenNames> = {
  ...stepNamesConst,
  ERROR: 'ERROR',
  THIRD_PARTY: 'THIRD_PARTY',
};

export const errorTypes: Record<errorNames, string> = {
  INVALID_ATTRIBUTE_TYPE: 'El tipo de dato ingresado no es válido',
  INVALID_ATTRIBUTE_LENGTH: 'El largo del valor no es válido',
  INVALID_ATTRIBUTE_RANGE: 'El valor ingresado está fuera de rango',
  INVALID_ATTRIBUTE_ENUM_CODE: 'El código no es válido',
  INVALID_ATTRIBUTE_FORMAT: 'El valor ingresado no posee el formato correcto',
  INVALID_BANK_ACCOUNT_REFERENCE: 'Esta cuenta no es válida',
  DISABLED_BANK_ACCOUNT_REFERENCE: 'Esta cuenta no está habilitada',
  BANK_ACCOUNT_ALREADY_REGISTERED: 'Esta cuenta ya se encuentra registrada',
  REQUIRED_ATTRIBUTE: 'Este campo es requerido',
  INVALID_ATTRIBUTE: 'El valor ingresado no es válido',
  MOBILE_PHONE_NUMBER_ALREADY_REGISTERED: 'El número de celular ya se encuentra registrado',
  EMAIL_ALREADY_REGISTERED: 'Este email ya está registrado. Probá con otro.',
  INVALID_OTP: 'El código ingresado no es válido',
  INSUFFICIENT_FUNDS: 'Hubo un inconveniente con la tarjeta seleccionada',
  INVALID_STEP: 'Hubo un inconveniente con el paso actual',
  STEP_MISMATCH: 'El paso enviado no coincide con el esperado',
};

export const provinces = [
  'BUENOS_AIRES',
  'CAPITAL_FEDERAL',
  'CATAMARCA',
  'CHACO',
  'CHUBUT',
  'CORDOBA',
  'CORRIENTES',
  'ENTRE_RIOS',
  'FORMOSA',
  'JUJUY',
  'LA_PAMPA',
  'LA_RIOJA',
  'MENDOZA',
  'MISIONES',
  'NEUQUEN',
  'RIO_NEGRO',
  'SALTA',
  'SAN_JUAN',
  'SAN_LUIS',
  'SANTA_CRUZ',
  'SANTA_FE',
  'SANTIAGO_DEL_ESTERO',
  'TIERRA_DEL_FUEGO',
  'TUCUMAN',
];

export const salesChannelsConst = {
  IN_STORE: 'Tienda física',
  ECOMMERCE: 'Tienda virtual/ecommerce',
  OMNICHANNEL: 'Tienda física y tienda virtual/ecommerce',
};

export enum EcommercePlatformEnum {
  TIENDANUBE = 'TIENDANUBE',
  PRESTASHOP = 'PRESTASHOP',
  WOOCOMMERCE = 'WOOCOMMERCE',
  VTEX = 'VTEX',
  MAGENTO = 'MAGENTO',
  OTHER = 'OTHER',
}

export const ECOMMERCE_PLATFORM_LABELS: Record<EcommercePlatformEnum, string> = {
  [EcommercePlatformEnum.TIENDANUBE]: 'Tiendanube',
  [EcommercePlatformEnum.PRESTASHOP]: 'PrestaShop',
  [EcommercePlatformEnum.WOOCOMMERCE]: 'WooCommerce',
  [EcommercePlatformEnum.VTEX]: 'VTEX',
  [EcommercePlatformEnum.MAGENTO]: 'Magento',
  [EcommercePlatformEnum.OTHER]: 'Otra',
};

export type GenderEnum = 'MALE' | 'FEMALE';
export type ApiMaritalStatusEnum = 'MARRIED' | 'DIVORCED' | 'SINGLE' | 'CIVIL_UNION' | 'COMMON_LAW_UNION' | 'WIDOWED';
export type OccupationEnum =
  'MERCHANT' | 'UNEMPLOYED' | 'EMPLOYED' | 'STUDENT' | 'RETIRED' | 'AGRICULTURAL_PRODUCER' | 'PROFESSIONAL';
export type TaxConditionEnum =
  | 'CONSUMIDOR_FINAL'
  | 'IVA_NO_RESPONSABLE'
  | 'IVA_RESPONSABLE_INSCRIPTO'
  | 'IVA_RESPONSABLE_NO_INSCRIPTO'
  | 'IVA_SUJETO_EXENTO'
  | 'RESPONSABLE_MONOTRIBUTO'
  | 'SUJETO_NO_CATEGORIZADO';
export type PepReasonEnum =
  'OTHER_PEP' | 'FOREIGN_PEP' | 'NATIONAL_PROVINCIAL_MUNICIPAL_OR_CABA_PEP' | 'PEP_BY_FAMILY_OR_CLOSE_ASSOCIATION';

export const productCodesConst = {
  BNPL: 'Cuotas sin interés con débito',
  ELECTRO: 'Electro',
  MOTO: 'Moto',
};

// Terms the mock REVIEW_AND_SUBMIT steps show
const mockTermsAndConditions =
  '<p>POR FAVOR, LEA CUIDADOSAMENTE ESTOS TÉRMINOS Y CONDICIONES DE USO DEL PRESENTE SITIO WEB, PARA SU CORRECTA UTILIZACIÓN. Los presentes términos y condiciones generales de uso (los “Términos y Condiciones”) serán aplicables al uso y contratación de los servicios ofrecidos por CREDITO DIRECTO S.A. CUIT 30-71210113-6 con domicilio en Av. Corrientes Nº 1174, Piso 7°, Ciudad Autónoma de Buenos Aires ( en adelante "Directo"), a través de la aplicación informática diseñada para ser ejecutada en teléfonos inteligentes y otros dispositivos móviles denominada directo (la "Aplicación"), a través del sitio web Crédito Directo  y/o relacionados de cualquier manera con el sitio web (en adelante, el “Sitio Web”). Cualquier persona (en adelante "Usuario" o en plural "Usuarios") que desee acceder y/o utilizar el Sitio Web y/o la Aplicación y/o utilizar cualquiera de los servicios en él ofrecidos deberá leer atentamente los Términos y Condiciones y, en su caso, aceptar dichos Términos y Condiciones sin restricción, reserva o modificación alguna con carácter previo a completar su proceso de registración en Sitio Web y/o la Aplicación, junto con todas las demás políticas de Directo que se encontraren vigentes, o tal como las mismas sean modificadas y/o actualizadas por Directo en el futuro.</p>';

const onbEfectivoFlow = {
  id: 'ad5b0908-9450-426f-b363-20be7482c0b6',
  flowName: 'onbEfectivo',
  variables: {
    email: 'a@a.com',
    gender: 'MALE',
    lastName: 'SUAREZ',
    province: 'FORMOSA',
    firstName: 'GABRIEL GONZALO',
    policyMaximumAmount: 500000.0,
    policyMinimumAmount: 0.0,
    desiredAmount: 10000,
    documentNumber: '45511908',
    mobilePhoneNumber: '1161998576',
    requestedAmount: 250000,
  },
  steps: [
    {
      id: 'd966adfb-59a8-4bd1-baa3-ac101ad4e7f3',
      name: 'CUSTOMER_IDENTIFICATION',
      variables: {
        gender: 'MALE',
        documentNumber: '12123123',
      },
      submittedAt: '2024-05-12T12:32:57',
    },
    {
      id: '473dbbfa-ed46-409f-9d4c-b8f16e79ffb3',
      name: 'CUSTOMER_REGISTRATION',
      variables: {
        fullNames: ['Sergio Dembis', 'Alberto Mágico'],
        fullName: 'Sergio Dembis',
      },
    },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'CONTACT_INFORMATION',
      variables: {
        email: 'a@a.com',
        mobilePhoneNumber: '1101091939',
        province: 'SAN_JUAN',
      },
    },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'SMS_VERIFICATION',
      variables: {
        smsOtp: '1234',
      },
    },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'LOAN_AMOUNT_AND_PURPOSES',
      variables: {
        desiredAmount: 400000,
        loanPurposes: ['electro', 'other'],
      },
    },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'REPAYMENT_TERMS',
      variables: {
        requestedAmount: 400000,
        installmentPlanId: 31,
      },
    },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'BANK_ACCOUNT_REFERENCE',
      variables: {
        bankAccountReference: '0290000100000000058382',
      },
    },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'PAYMENT_METHOD',
      variables: {
        paymentMethod: 'CARD',
        cardId: '1234',
      },
    },
    // {
    //   id: '663ccf91-a34c-4bda-a697-621a526bf739',
    //   name: 'EMAIL_VERIFICATION',
    // },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'IDENTITY_VERIFICATION_START',
      variables: {
        clientId: '64efa006d9dcda001b258cdb',
        flowId: '64efa006d9dcda001b258cd9',
      },
    },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'REVIEW_AND_SEND_LINK',
      variables: {
        requestedAmount: 334000,
        installmentAmount: 102977,
        installmentCount: 9,
        installmentRates: {
          CFT: 271,
          TEA: 1051.27,
          TEM: 22.58,
          TNA: 271,
          CFTNA: 273.69,
          CFTTEA: 1080.66,
        },
        installmentFirstDueDate: '2024-10-07',
        paymentMethod: 'CASH',
        bankAccountReference: '0290000100000000058382',
        cardType: 'DEBIT',
        cardIssuer: 'Visa',
        cardNumber: '2345********3345',
        paymentSchedule: [
          {
            number: 1,
            amount: 102977,
            dueDate: '2024-10-07',
          },
          {
            number: 2,
            amount: 102977,
            dueDate: '2024-11-07',
          },
          {
            number: 3,
            amount: 102977,
            dueDate: '2024-12-07',
          },
          {
            number: 4,
            amount: 102977,
            dueDate: '2025-01-07',
          },
          {
            number: 5,
            amount: 102977,
            dueDate: '2025-02-07',
          },
          {
            number: 6,
            amount: 102977,
            dueDate: '2025-03-07',
          },
          {
            number: 7,
            amount: 102977,
            dueDate: '2025-04-07',
          },
          {
            number: 8,
            amount: 102977,
            dueDate: '2025-05-07',
          },
          {
            number: 9,
            amount: 102977,
            dueDate: '2025-06-07',
          },
        ],
        documentNumber: '32784234',
        gender: 'MALE',
        fullName: 'KURYLEC, ANDRES',
        birthDate: '1995-11-03',
        taxpayerId: '20327842340',
        email: 'akurylec@directo.com.ar',
        mobilePhoneNumber: '1161998576',
        province: 'BUENOS_AIRES',
      },
    },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'REVIEW_AND_SUBMIT',
      variables: {
        hasTermsAccepted: true,
        requestedAmount: 334000,
        installmentAmount: 102977,
        installmentCount: 9,
        installmentRates: {
          CFT: 271,
          TEA: 1051.27,
          TEM: 22.58,
          TNA: 271,
          CFTNA: 273.69,
          CFTTEA: 1080.66,
        },
        installmentFirstDueDate: '2024-10-07',
        paymentMethod: 'CASH',
        bankAccountReference: '0290000100000000058382',
        cardType: 'DEBIT',
        cardIssuer: 'Visa',
        cardNumber: '2345********3345',
        paymentSchedule: [
          {
            number: 1,
            amount: 102977,
            dueDate: '2024-10-07',
          },
          {
            number: 2,
            amount: 102977,
            dueDate: '2024-11-07',
          },
          {
            number: 3,
            amount: 102977,
            dueDate: '2024-12-07',
          },
          {
            number: 4,
            amount: 102977,
            dueDate: '2025-01-07',
          },
          {
            number: 5,
            amount: 102977,
            dueDate: '2025-02-07',
          },
          {
            number: 6,
            amount: 102977,
            dueDate: '2025-03-07',
          },
          {
            number: 7,
            amount: 102977,
            dueDate: '2025-04-07',
          },
          {
            number: 8,
            amount: 102977,
            dueDate: '2025-05-07',
          },
          {
            number: 9,
            amount: 102977,
            dueDate: '2025-06-07',
          },
        ],
        documentNumber: '32784234',
        gender: 'MALE',
        fullName: 'KURYLEC, ANDRES',
        birthDate: '1995-11-03',
        taxpayerId: '20327842340',
        email: 'akurylec@directo.com.ar',
        mobilePhoneNumber: '1161998576',
        province: 'BUENOS_AIRES',
        termsAndConditions: mockTermsAndConditions,
      },
    },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'SUCCESS',
    },
  ],
  createdAt: '2024-05-12T09:32:24',
};

// Order the mock onb-cuotas instance pays: the one in the mock order credential
const mockCuotasOrder = {
  returnURLError: 'http://eccomerce-site/error',
  returnURLSuccess: 'http://eccomerce-site/success',
  integrationType: 'API',
  orderId: '37',
  policyProduct: 'ELECTROBNPL',
  merchantName: 'API_USER_BNPL',
  merchantOrderId: 'GYJX591762',
  price: '10023.34',
};

const mockCuotasSchedule = [
  { number: 1, amount: 1670.56, dueDate: '2024-10-07' },
  { number: 2, amount: 1670.56, dueDate: '2024-11-07' },
  { number: 3, amount: 1670.56, dueDate: '2024-12-07' },
  { number: 4, amount: 1670.56, dueDate: '2025-01-07' },
  { number: 5, amount: 1670.56, dueDate: '2025-02-07' },
  { number: 6, amount: 1670.56, dueDate: '2025-03-07' },
];

// What the review steps show for the mock onb-cuotas instance
const mockCuotasReview = {
  requestedAmount: 10023.34,
  installmentAmount: 1670.56,
  installmentCount: 6,
  installmentRates: {
    CFT: 0,
    TEA: 0,
    TEM: 0,
    TNA: 0,
    CFTNA: 0,
    CFTTEA: 0,
  },
  installmentFirstDueDate: '2024-10-07',
  installmentPlanType: 'DEFERRED_PAYMENT',
  withInterest: false,
  paymentMethod: 'DEBIT_CARD',
  cardType: 'DEBIT',
  cardIssuer: 'Visa',
  cardNumber: '4704********0005',
  paymentSchedule: mockCuotasSchedule,
  documentNumber: '30123456',
  gender: 'MALE',
  fullName: 'PEREZ, JUAN',
  birthDate: '1983-04-12',
  taxpayerId: '20301234569',
  email: 'juan.perez@mail.com',
  mobilePhoneNumber: '1165554422',
  province: 'BUENOS_AIRES',
};

const onbCuotasFlow = {
  id: 'ad5b0908-9450-426f-b363-20be7482c0b6',
  flowName: 'onbCuotas',
  variables: {
    email: 'juan.perez@mail.com',
    gender: 'MALE',
    lastName: 'PEREZ',
    province: 'BUENOS_AIRES',
    firstName: 'JUAN',
    policyMaximumAmount: 500000.0,
    policyMinimumAmount: 0.0,
    desiredAmount: 10023.34,
    documentNumber: '30123456',
    mobilePhoneNumber: '1165554422',
    requestedAmount: 10023.34,
    // The order the instance was created for, as the backend keeps it: the steps show it
    additionalData: JSON.stringify(mockCuotasOrder),
  },
  steps: [
    {
      id: 'd966adfb-59a8-4bd1-baa3-ac101ad4e7f3',
      name: 'CUSTOMER_IDENTIFICATION',
      variables: {
        gender: 'MALE',
        documentNumber: '30123456',
      },
      submittedAt: '2024-05-12T12:32:57',
    },
    {
      id: '473dbbfa-ed46-409f-9d4c-b8f16e79ffb3',
      name: 'CUSTOMER_REGISTRATION',
      variables: {
        fullNames: ['Sergio Dembis', 'Alberto Mágico'],
        fullName: 'Sergio Dembis',
      },
    },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'CONTACT_INFORMATION',
      variables: {
        email: 'juan.perez@mail.com',
        mobilePhoneNumber: '1165554422',
        province: 'BUENOS_AIRES',
      },
    },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'SMS_VERIFICATION',
      variables: {
        smsOtp: '1234',
      },
    },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'REPAYMENT_TERMS',
      variables: {
        requestedAmount: 10023.34,
        installmentPlanId: 31,
      },
    },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'PAYMENT_METHOD',
      variables: {
        paymentMethod: 'DEBIT_CARD',
        cardId: 365850,
      },
    },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'IDENTITY_VERIFICATION_START',
      variables: {
        clientId: '64efa006d9dcda001b258cdb',
        flowId: '64efa006d9dcda001b258cd9',
      },
    },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'REVIEW_AND_SEND_LINK',
      variables: mockCuotasReview,
    },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'REVIEW_AND_SUBMIT',
      variables: {
        hasTermsAccepted: true,
        ...mockCuotasReview,
        termsAndConditions: mockTermsAndConditions,
      },
    },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'SUCCESS',
      variables: {
        firstName: 'JUAN',
        installmentPlanType: 'DEFERRED_PAYMENT',
        newCustomer: true,
      },
    },
  ],
  createdAt: '2024-05-12T09:32:24',
};

const onbComerciosFlow = {
  id: 'ad5b0908-9450-426f-b363-20be7482c0b6',
  flowName: 'onbComercios',
  variables: {
    email: 'a@a.com',
    gender: 'MALE',
    lastName: 'SUAREZ',
    province: 'FORMOSA',
    firstName: 'GABRIEL GONZALO',
    policyMaximumAmount: 500000.0,
    policyMinimumAmount: 0.0,
    desiredAmount: 10000,
    documentNumber: '45511908',
    mobilePhoneNumber: '1161998576',
    requestedAmount: 250000,
  },
  steps: [
    {
      id: 'd966adfb-59a8-4bd1-baa3-ac101ad4e7f3',
      name: 'MERCHANT_IDENTIFICATION',
      variables: {
        taxpayerId: '30697465983',
        tradeName: 'NALDO LOMBARDI SA',
        salesChannel: 'E_COMMERCE',
        localityId: 21727,
        streetName: 'Calle falsa',
        streetNumber: '123',
        postalCode: '1636',
        productCodes: ['BNPL'],
      },
      submittedAt: '2024-05-12T12:32:57',
    },
    {
      id: '473dbbfa-ed46-409f-9d4c-b8f16e79ffb3',
      name: 'MERCHANT_CONTACT_INFORMATION',
      variables: {
        firstName: 'JUAN',
        lastName: 'PEREZ',
        email: 'juanperez@naldo.com.ar',
        mobilePhoneNumber: '1165554422',
      },
    },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'SMS_VERIFICATION',
      variables: {
        smsOtp: '1234',
      },
    },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'IDENTITY_VERIFICATION_START',
      variables: {
        clientId: '64efa006d9dcda001b258cdb',
        flowId: '64efa006d9dcda001b258cd9',
      },
    },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'REVIEW_AND_SUBMIT',
      variables: {
        hasTermsAccepted: true,
        taxpayerId: '20123407572',
        tradeName: 'NALDO LOMBARDI SA',
        legalName: 'NALDO LOMBARDI SA',
        email: 'juanperez@naldo.com.ar',
        mobilePhoneNumber: '1165554422',
        identityVerificationDocumentNumber: '33980837',
        identityVerificationGender: 'MALE',
        termsAndConditions: mockTermsAndConditions,
      },
    },
    {
      id: '663ccf91-a34c-4bda-a697-621a526bf739',
      name: 'SUCCESS',
      variables: {
        documentTypes: [
          {
            documentType: 'ACTA_ASAMBLEA',
            title: 'Acta de Asamblea de designación de presidente',
            required: true,
          },
          {
            documentType: 'COMPROBANTE_CBU',
            title: 'Comprobante de CBU',
            required: true,
          },
          {
            documentType: 'ESTATUTO_SA',
            title: 'Estatuto',
            required: true,
          },
          {
            documentType: 'CONSTANCIA_INSCRIPCION_IIBB',
            title: 'Constancia de inscripción actualizada y última DDJJ de IIBB',
            required: true,
          },
          {
            documentType: 'DNI_PRESIDENTE',
            title: 'Frente y dorso DNI del presidente',
            required: true,
          },
          {
            documentType: 'ACTA_DIRECTORIO',
            title: 'Acta de Directorio que aprueba otorgamiento de poder',
            required: true,
          },
          {
            documentType: 'DNI_APODERADO',
            title: 'DNI apoderado',
            required: true,
          },
          {
            documentType: 'CONSTANCIA_INSCRIPCION_AFIP',
            title: 'Constancia de inscripción en AFIP',
            required: true,
          },
        ],
      },
    },
  ],
  createdAt: '2024-05-12T09:32:24',
};

/** Mock flow of this instance type: the steps the mock flow-instances routes and the dev tools walk through. */
export const onbCompleteFlow =
  process.env.NEXT_PUBLIC_ONB_INSTANCE_TYPE === 'onb-comercios'
    ? onbComerciosFlow
    : process.env.NEXT_PUBLIC_ONB_INSTANCE_TYPE === 'onb-cuotas'
      ? onbCuotasFlow
      : onbEfectivoFlow;

export const termsAndConditions = `Datos Personales. Por el presente garantizo la veracidad, exactitud,   
vigencia, y autenticidad de los Datos Personales declarados en el   
presente documento y/o proceso y durante la vigencia del vínculo   
contractual, cualquier sea el medio de recopilación que se utilice, los   
cuales comprendo, formarán parte de un banco de datos electrónicos   
registrado ante la Agencia de Acceso a la Información Pública (AAIP)   
cuya propiedad es de Crédito Directo S.A., con domicilio legal en Tte.   
Gral. Juan Domingo Perón 646, Piso 4° de la Ciudad Autónoma de Buenos Aires ,   
Argentina.
<br><br>
Asimismo, presto mi expreso consentimiento para Crédito Directo S.A   
trate, comparta, ceda y/o transfiera los Datos Personales, incluidos   
datos de identificación y vinculación comercial, calificación crediticia   
y/o legajos y/o el análisis del origen y licitud de mis fondos, a sus   
afiliadas, subsidiarias, compañías controladas, controlantes o   
vinculadas y/o relacionadas (las “Sociedades vinculadas”) y/o a terceros   
que asistan en la prestación de servicios con las siguientes finalidades:   
i) Identificación, validación de identidad, confrontación de los Datos   
Personales (incluyendo los datos biométricos) con la base de datos del   
Registro Nacional de las Personas (RENAPER); ii) Fines comerciales,   
estadísticos, publicitarios, operativos, administrativos, de evaluación   
y/o gestión de riesgos, de marketing, de gestión y/o comercialización   
de servicios compartidos y/o de servicios y/o productos propios de cada   
sociedad; iii) Apertura/Alta de cuentas y/o servicios y/o en relación   
al vínculo comercial que mantenga con Crédito Directo S.A y/o con las   
Sociedades Vinculadas; iv) Cumplimiento de la normativa en materia de   
prevención de lavado de activos, financiación del terrorismo y   
financiamiento de armas de proliferación masiva y sus obligaciones   
legales relacionadas; v) Envío de notificaciones, noticias y novedades   
que revistan el carácter de notificaciones de índole institucional o   
legal; vi) Ejecución de auditorías.
<br><br>
Comprendo y acepto expresamente que los Datos Personales podrán ser   
alojados y/o tratados en servidores propios de Crédito Directo S.A ó   
de terceros en Argentina o en servidores de terceros en países que   
podrían contar o no con los niveles de protección adecuados. Comprendo   
que, en caso de que los datos se transfieran a países con niveles no   
adecuados de protección, se realizarán las salvaguardas y medidas de   
seguridad adecuadas.
<br><br>
Asimismo comprendo y acepto que Crédito Directo S.A se reserva el   
derecho de ceder o transferir los Datos Personales en caso de venta o   
fusión de la compañía, o de una adquisición de sus activos principales   
por parte un tercero y que podrá divulgar los Datos Personales brindados   
a los efectos de: a) protegerse de una responsabilidad legal; b) cumplir   
requerimientos, exigencias legales u órdenes judiciales; c) proteger mis   
derechos, propiedad y/o seguridad, así como la de Crédito Directo S.A   
y la de terceros.
<br><br>
Finalmente, como titular de los Datos Personales, comprendo que:
<br><br>
• Poseo la facultad de acceder a los mismos enviando un correo   
electrónico a la siguiente casilla privacidad@gst.com.ar en   
cualquier momento y de forma gratuita a intervalos no inferiores   
a seis (6) meses, salvo que se acredite un interés legítimo al   
efecto conforme lo establecido en el artículo 14, inc. 3° de la   
Ley N° 25.326. Asimismo, podré solicitar la actualización,   
rectificación y supresión de mis Datos Personales en cualquier   
momento y de forma gratuita a la misma casilla de correo   
electrónico, siempre que las solicitudes no sean infundadas o   
abusivas.
<br><br>
• La autoridad de aplicación en la República Argentina en materia   
de Datos Personales es la Agencia de Acceso a la Información   
Pública (AAIP), órgano de control de la Ley Nº 25.326 (Protección   
de los Datos Personales). Comprendo que dicho órgano tiene la   
atribución de atender las denuncias y reclamos que se interpongan   
con relación al incumplimiento de las normas sobre protección de   
datos personales y que podré contactar a la AAIP de manera   
presencial en la Av. Pte. Julio A. Roca 710, Piso 2º, Ciudad   
Autónoma de Buenos Aires (CP 1067), o vía web con el siguiente   
link www.argentina.gob.ar/aaip, vía correo electrónico a la   
casilla info@aaip.gob.ar, o por teléfono al + 54 9 11-2821-0047.
<br><br>
• Que el retiro del consentimiento por mi parte no invalidará las   
acciones previamente realizadas por Crédito Directo S.A.`;
